<template>
    <Tabs
        v-if="loaded"
        :data="{ form, model }"
    />
</template>

<script>

// Mixins
import { repository, stringCase, object, error } from "@/mixins";

// Vuex.
import { mapActions } from "vuex";

// Components
import Tabs from './Tabs'

export default {
    components: { Tabs },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('atencaoBasica.parametrizacao')
        }

        this.load()
    },
    data: () => ({
        form: {},
        model: {},
        loaded: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.parametrizacao.index()
                .then(response => {

                    this.model = Object.assign(response.data.model)
                    this.form = Object.assign(response.data.form)

                    this.$emit('model-load', this.model)

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.setLoading()

            const modelSnakeCase = this.prepareData()

            const request = this.repositories.parametrizacao.store(modelSnakeCase)

            request
                .then(response => {

                    this.showSaveNotification()
                    this.$emit('save', response)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        obterDadosArea() {

            const dadosAreas = this.clone(this.model.area.areas)

            const areas = dadosAreas.map(area => {

                const microareas = area.microareas.map(microarea => {

                    return {
                        id: microarea.id ?? null,
                        descricao: microarea.descricao
                    }
                })

                return {
                    id: isNaN(area.id) ? null : area.id,
                    descricao: area.descricao,
                    numeroIne: area.numeroIne,
                    tipoId: area.tipoId,
                    microareas: microareas
                }
            })

            return areas
        },
        obterDadosEquipe() {

            const dadosEquipes = this.clone(this.model.equipe.equipes)

            const equipes = dadosEquipes.map(equipe => {

                const profissionais = equipe.usuarios.map(usuario => {

                    return {
                        id: usuario.id,
                        ativo: usuario.ativo ? '1' : '0'
                    }
                })

                return {
                    id: equipe.id ?? null,
                    areaId: equipe.areaId,
                    microareaId: equipe.microareaId,
                    unidadeId: equipe.unidadeId,
                    infraestruturaId: equipe.infraestruturaId,
                    profissionais: profissionais,
                }
            })

            return equipes
        },
        obterDadosFaturamentoAtendimentoDomiciliar() {

            const dadosAtendimentoDomiciliar = this.clone(this.model.faturamento.atendimentoDomiciliar)

            return {
                registroTipoId: dadosAtendimentoDomiciliar.registroTipoId ?? null
            }
        },
        obterDadosFaturamentoFuncionalidades() {

            const dadosFuncionalidades = this.clone(this.model.faturamento.funcionalidades)

            const funcionalidades = dadosFuncionalidades.map(funcionalidade => {

                return {
                    id: funcionalidade.id,
                    faturar: funcionalidade.faturar ? '1' : '0',
                }
            })

            return funcionalidades
        },
        obterDadosFaturamentoProcedimentos() {

            const dadosGrupoProcedimentos = this.clone(this.model.faturamento.grupoProcedimentos)

            var procedimentos = []

            dadosGrupoProcedimentos.forEach(grupo => {

                grupo.procedimentos.forEach(procedimento => {

                    procedimentos.push({
                        id: procedimento.id,
                        faturar: procedimento.faturar
                    })
                })
            })

            return procedimentos
        },
        obterDadosFaturamento() {

            return {
                atendimentoDomiciliar: this.obterDadosFaturamentoAtendimentoDomiciliar(),
                funcionalidades: this.obterDadosFaturamentoFuncionalidades(),
                procedimentos: this.obterDadosFaturamentoProcedimentos(),
            }
        },
        obterDadosOutrosSupervisor() {

            return this.clone(this.model.outros.supervisores)
                .map((supervisor) => ({
                    id: supervisor.id ?? null,
                    usuarioId: supervisor.usuarioId
                }))
        },
        obterDadosOutrosPermissao() {

            const dadosPermissoes = this.clone(this.model.outros.permissao)

            const permissoes = dadosPermissoes.map(permissao => {

                const ocupacoes = permissao.ocupacoes.map(ocupacao => ({
                    id: null,
                    ocupacao: ocupacao.codigo
                }))

                return {
                    id: permissao.id,
                    ocupacoes: ocupacoes
                }
            })

            return permissoes
        },
        obterDadosOutros() {

            return {
                salarioMinimo: this.clone(this.model.outros.salarioMinimo),
                supervisores: this.obterDadosOutrosSupervisor(),
                permissao: this.obterDadosOutrosPermissao(),
            }
        },
        prepareData() {

            const model = {
                areas: this.obterDadosArea(),
                equipes: this.obterDadosEquipe(),
                faturamento: this.obterDadosFaturamento(),
                outros: this.obterDadosOutros(),
            }

            return this.camelObjectKeysToSnakeRecursive(model)
        },
    },
    mixins: [repository, stringCase, object, error],
}
</script>